<template>
	<div>
		<ConsoleEventArg
			v-for="(arg, index) in argsWithoutStyles"
			:key="index"
			:renderAs="getComponentName(arg)"
			:value="arg"
			class="mr-8 align-top inline-block"
			:class="wrap ? 'break-all whitespace-normal' : 'whitespace-nowrap'"
			:wrap="wrap"
			root
		/>
	</div>
</template>

<script>
export default {
	name: 'ConsoleEventArgs',
	props: {
		args: Array,
		wrap: Boolean,
	},
	computed: {
		argsWithoutStyles() {
			return this.removeStyles(this.args)
		},
	},
	methods: {
		removeStyles(args) {
			if (!args?.[0]) {
				return args
			}
			if (typeof args[0] !== 'string') {
				return args
			}

			const styles = args[0].match(/%c/g)
			if (styles) {
				// remove %c string from first string
				args[0] = args[0].replace(/%c/g, '')
				// remove elements in args array
				args.splice(1, styles.length)
			}
			return args
		},
		getComponentName(arg) {
			// new session events shouldn't contain arrays anymore,
			// however sessions generated before 1.3.16 used to contain raw arrays
			// in the console args
			if (Array.isArray(arg)) {
				return 'ArgArray'
			}

			if (typeof arg === 'object' && arg !== null) {
				return 'ArgSerialized'
			}
			return 'ArgValue'
		},
	},
}
</script>
